import styled from 'styled-components';

import { IconInfo, IconTick } from '@xingternal/icons';
import { scale080, space3XL, spaceM, spaceXL, xdlColorBorderSoft } from '@xingternal/tokens';
import { Meta } from '@xingternal/typography';

export const VariantsContainer = styled.div`
  border-top: 1px solid ${xdlColorBorderSoft};
  font-size: ${scale080};
  padding: ${space3XL} 0 ${spaceXL};
  text-align: center;
  width: 100%;

  a {
    cursor: pointer;
  }
`;

export const VariantTitle = styled.strong`
  position: relative;
  padding-left: ${spaceXL};
`;

export const VariantText = styled(Meta)`
  margin: ${spaceM} 0 0;

  span {
    display: block;
    margin: ${spaceM} 0 0;
  }
`;

export const StyledIconInfo = styled(IconInfo)`
  position: absolute;
  top: 0;
  left: 0;
`;

export const StyledIconTick = styled(IconTick)`
  position: absolute;
  top: 0;
  left: 0;
`;
